module.exports = "/_next/static/images/block1-1879c485f078bc431fe9a160cd4ee9e5.svg";